// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { ACCOUNTING_DIRECTION } from '../../constants/accountingDirection';

// Money between a system account and a gateway: the owner's advance payments
// (deposit) and our payments to them (withdrawal). Counted in the gateway's
// balance — negative when prepaid — in its balance currency, which the backend
// stamps on each row; a gateway without a balance currency is refused. It never
// reaches a wallet: wallets have takings, and Wallet transfers move those between
// a gateway's cards.
export default class GatewayTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingGatewayTransactions';
        this.Server = this.props.context.getState().server.accountingGatewayTransactions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'note'];

        const defaultHead = [
            { id: 'uuid', label: 'uuid', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            {
                id: 'gatewayId', required: true,
                label: 'gateway',
                alignRight: false,
                cell: 'Select',
                from: 'publicGateways',
                object: 'gateway',
                show: 'name',
                displayGrid: true
            },
            {
                id: 'systemAccountId', required: true,
                label: 'systemAccount',
                alignRight: false,
                cell: 'Select',
                from: 'accountingSystemAccounts',
                object: 'systemAccount',
                show: 'name',
                displayGrid: true
            },
            {
                id: 'direction', required: true,
                label: 'direction',
                alignRight: false,
                cell: 'Items',
                items: ACCOUNTING_DIRECTION,
                enumGroup: 'gatewayDirection',
                displayGrid: true
            },
            // In the gateway's balance currency.
            {
                id: 'gatewayAmount', required: true,
                label: 'gatewayAmount',
                alignRight: true,
                cell: 'Amount',
                currencyObject: 'currency',
                displayGrid: true
            },
            { id: 'systemAmount', required: true, label: 'systemAmount', alignRight: true, cell: 'Amount', displayGrid: true },
            { id: 'note', label: 'note', alignRight: false, cell: 'BigText', displayGrid: true },
            { id: 'paymentDate', label: 'paymentDate', alignRight: false, cell: 'DateTime', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
